import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { RiDeleteBin6Line } from "react-icons/ri";
import { RiVideoLine } from "react-icons/ri";

import styles from "./MultipleProductImages.module.css";

const MultipleProductImages = () => {
  const [images, setImages] = useState([]);
  const [videoLink, setVideoLink] = useState("");

  const handleImages = (e) => {
    const files = Array.from(e.target.files);

    const formatted = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setImages((prev) => [...prev, ...formatted]);
  };

  const removeImage = (index) => {
    const updated = [...images];
    updated.splice(index, 1);
    setImages(updated);
  };

  return (
    <div>
      {/* Top Section */}
      <Row className="g-2">
        {/* Upload Box */}
        <Col lg={5}>
          <label className={styles.uploadBox}>
            <input
              type="file"
              multiple
              hidden
              accept="image/*"
              onChange={handleImages}
            />

            <div className={styles.uploadContent}>
              <h6>Upload Images</h6>
              <p>Multiple product images</p>
            </div>
          </label>
        </Col>

        {/* Video Link */}
        <Col lg={7}>
          <div className={styles.videoSection}>
            {/* <div className={styles.videoTitle}>
              <RiVideoLine size={16} />
              Product Video Link
            </div> */}

            <Form.Control
              as="textarea"
              rows={3}
              value={videoLink}
              placeholder="https://youtube.com/watch?v=..."
              className={styles.videoTextarea}
              onChange={(e) =>
                setVideoLink(e.target.value)
              }
            />
          </div>
        </Col>
      </Row>

      {/* Images Preview */}
      {images.length > 0 && (
        <Row className="g-2 mt-2">
          {images.map((img, index) => (
            <Col
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={6}
              key={index}
            >
              <div className={styles.imageCard}>
                <img
                  src={img.preview}
                  alt="product"
                  className={styles.image}
                />

                <button
                  className={styles.deleteBtn}
                  onClick={() => removeImage(index)}
                >
                  <RiDeleteBin6Line size={16} />
                </button>
              </div>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default MultipleProductImages;